import React from "react";
import { Box, Skeleton, LinearProgress, Typography } from "@mui/material";

export const LoaderSpinner = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

// Componente de skeleton para tablas
export const TableSkeleton = ({ rows = 5, columns = 4 }) => {
  return (
    <Box sx={{ width: "100%" }}>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <Box key={rowIndex} sx={{ display: "flex", gap: 1, mb: 1 }}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <Skeleton
              key={colIndex}
              variant="rectangular"
              width={colIndex === 0 ? 80 : colIndex === columns - 1 ? 120 : 150}
              height={40}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};

// Componente de skeleton para órdenes
export const OrderSkeleton = () => {
  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Skeleton variant="text" width="60%" height={32} sx={{ mb: 2 }} />
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <Skeleton variant="rectangular" width={100} height={40} />
        <Skeleton variant="rectangular" width={120} height={40} />
        <Skeleton variant="rectangular" width={200} height={40} />
        <Skeleton variant="rectangular" width={80} height={40} />
        <Skeleton variant="rectangular" width={80} height={40} />
        <Skeleton variant="rectangular" width={100} height={40} />
        <Skeleton variant="rectangular" width={100} height={40} />
        <Skeleton variant="rectangular" width={60} height={40} />
      </Box>
    </Box>
  );
};

// Componente de indicador de progreso
export const LoadingProgress = ({ message = "Cargando datos...", progress = 0 }) => {
  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {message}
      </Typography>
      <LinearProgress 
        variant="determinate" 
        value={progress} 
        sx={{ 
          height: 8, 
          borderRadius: 4,
          backgroundColor: '#f0f0f0',
          '& .MuiLinearProgress-bar': {
            borderRadius: 4,
            backgroundColor: '#b91411'
          }
        }} 
      />
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        {Math.round(progress)}% completado
      </Typography>
    </Box>
  );
};
